<script>
    import { deleteCompany } from "../Company.svelte";
    import LoadingModal from "./LoadingModal.svelte";

    import Card, {Content, PrimaryAction, Media, MediaContent, Actions, ActionButtons, ActionIcons} from '@smui/card';
    import Button, {Label} from '@smui/button';
    import IconButton, {Icon} from '@smui/icon-button';
    import Menu, {SelectionGroup, SelectionGroupIcon} from '@smui/menu';
    import {Anchor} from '@smui/menu-surface';
    import List, {Item, Separator, Text, PrimaryText, SecondaryText, Graphic} from '@smui/list';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    // data model for project
    export let model;

    // variable to bind the popup menu to
    let popup;

    // the deletion request
    let deleteCompanyRequest;

    // flag signifying this company has been deleted
    let deleted = false;

    // determine logo for company.
    // TODO: this for now is hacky since it relies
    // on a localstorage image url set by the company creator.
    // this field should be included in the graphql schema
    $: imageUrl = localStorage.getItem(`${model.id}.logo`) || `https://picsum.photos/400/270?_pid=${model.id}`;

    // there may be a state where the card is still used,
    // so make sure we could hide it using this flag & class
    $: deleting = !!deleteCompanyRequest && !deleted;

    // issue the request to delete the company model
    // TODO: create proper Dialog for confirmation request
    // TODO: remove redundancy with project deletion op
    function deleteIt() {
        if (confirm("Are you sure you want to delete this company? This will archive all Projects that belong to it.")) {
            deleteCompanyRequest = deleteCompany(model.id)
                .then(res => {
                    console.log("successfully deleted company");
                    deleted = true;
                    dispatch("deleted", model);
                })
                .catch(err => {
                    dispatch("error", err)
                });
        }
    }
</script>

<Card class="company-card {deleted ? 'deleted' : ''}" style="width: 360px; position: relative;">
    <LoadingModal show={deleting} global={false} background="darken"/>
    <PrimaryAction on:click="">
        <Media class="card-media-16x9" aspectRatio="16x9" style="background-image: url({imageUrl});">
            <MediaContent>
                <div style="color: #fff; position: absolute; bottom: 16px; left: 16px;">
                    <h2 class="mdc-typography--headline6" style="margin: 0;">{model.name}</h2>
                    <h3 class="mdc-typography--subtitle2" style="margin: 0;">{model.websiteUrl}</h3>
                </div>
            </MediaContent>
        </Media>
<!--        <Content class="mdc-typography&#45;&#45;body2">-->
<!--            TODO: company description-->
<!--        </Content>-->
    </PrimaryAction>
    <Actions>
        <ActionButtons>
<!--            <Button on:click="">-->
<!--                <Label>Action</Label>-->
<!--            </Button>-->
<!--            <Button on:click="">-->
<!--                <Label>Another</Label>-->
<!--            </Button>-->
        </ActionButtons>
        <ActionIcons>
<!--            <IconButton on:click="" toggle aria-label="Add to favorites" title="Add to favorites">-->
<!--                <Icon class="material-icons" on>favorite</Icon>-->
<!--                <Icon class="material-icons">favorite_border</Icon>-->
<!--            </IconButton>-->
<!--            <IconButton class="material-icons" on:click="" title="Share">share</IconButton>-->
            <span>
                <IconButton class="material-icons" on:click={() => popup.setOpen(true)} title="More options">more_vert</IconButton>
                <Menu bind:this={popup}>
                    <List>
<!--                        <Item on:SMUI:action={()=>{}}><Text>Cut</Text></Item>-->
<!--                        <Item on:SMUI:action={()=>{}}><Text>Copy</Text></Item>-->
<!--                        <Item on:SMUI:action={()=>{}}><Text>Paste</Text></Item>-->
                        <Separator />
                        <Item on:SMUI:action={deleteIt} style="background: #C00; color: white;"><Text>Delete</Text></Item>
                    </List>
                </Menu>
            </span>
        </ActionIcons>
    </Actions>
</Card>